import { connect } from 'react-redux'
import { sagaActions } from '../../../sagas'
import CopyLayout from './CopyLayout'

export default connect(
  null,
  {
    requestCopyLayout: sagaActions.requestCopyLayout,
  }
)(CopyLayout)
